import { getAuthHeader } from './api'

/**
 * Servicio para importación de datos vía CSV
 * (usa fetch directo, igual que csvExport.ts, para no forzar
 * Content-Type: application/json del cliente axios sobre un
 * multipart/form-data)
 */

export interface ImportSource {
  key: string;
  label: string;
  expectedColumns: string[];
}

export interface ImportRowError {
  row: number;
  errors: string[];
}

export interface ImportResult {
  success: boolean;
  source?: string;
  totalRows?: number;
  inserted?: number;
  skipped?: number;
  errors?: ImportRowError[];
  message?: string;
  error?: string;
  expectedColumns?: string[];
  foundColumns?: string[];
  missingColumns?: string[];
  availableSources?: string[];
}

/**
 * Obtiene las fuentes de datos soportadas y las columnas que espera cada una
 */
export const getImportSources = async (): Promise<ImportSource[]> => {
  const response = await fetch('/api/data/import-csv', {
    headers: getAuthHeader(),
  });
  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || data.error || 'No se pudieron obtener las fuentes de importación');
  }

  return data.data;
};

/**
 * Sube un CSV y lo importa en la fuente indicada.
 * Devuelve el resultado tal cual lo manda el backend (éxito o error),
 * ya que un 400 con detalle de columnas/errores sigue siendo información
 * útil que la UI debe mostrar, no una excepción a capturar.
 */
export const importCSV = async (source: string, file: File): Promise<ImportResult> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`/api/data/import-csv?source=${encodeURIComponent(source)}`, {
    method: 'POST',
    headers: getAuthHeader(),
    body: formData,
  });

  return response.json();
};
